import { layoutCorrectionText, officialLayoutAssessment, type SeatCandidate } from '@anjabom/core';
import { Link } from 'react-router-dom';
import { ExternalLink } from './ExternalLink';

export function OfficialLayoutStatus({ candidate }: { candidate: SeatCandidate }) {
  const info = officialLayoutAssessment(candidate);
  return <section className="card stack" aria-label="공식 정보 확인 범위">
    <p><strong>{info.changed ? '시설 배치가 달라요' : '회차 배치는 모름이에요'}</strong> · {candidate.instanceLabel ?? '회차를 선택하지 않았어요'}</p>
    <details><summary>공식 출처·배치 확인과 정정</summary><div className="stack">
    <p>{info.statement}</p>
    {info.facility ? <p>{info.facility.statement} <span className="micro">시설 수량만 {info.facility.checkedAt} 확인했어요. 관람 후기나 회차 배치 확인은 아니에요.</span></p> : null}
    <p className="micro">좌표 출처 {info.layout?.source.checkedAt ?? '미확인'}{info.sourceRecheckDue ? ' · 30일이 지나 원문 재확인이 필요해요. 배치가 바뀌었다는 뜻은 아니에요.' : ''}</p>
    <p className="micro">선택한 배치 {candidate.layoutVersionId}</p>
    <div className="inline">
      {candidate.venueId === 'sejong-center' ? <ExternalLink className="button button-primary" href="https://www.sejongpac.or.kr/portal/performance/performance/performList.do?menuNo=200320">공식 공연·회차 찾기</ExternalLink> : null}
      {info.layout ? <ExternalLink className="button" href={info.layout.source.url}>공식 시설 배치 열기</ExternalLink> : null}
      <Link className="button" to="/support" state={{ layoutCorrection: layoutCorrectionText(candidate) }}>배치 정정 초안 만들기</Link>
      <Link to={`/start?venue=${encodeURIComponent(candidate.venueId)}`}>좌석 다시 고르기</Link>
    </div>
    </div></details>
  </section>;
}
